var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotMonitorable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.381 4.076a.96.96 0 01.319.224.96.96 0 01.1 1.4l-4.46 4.46.76.54v18.96a23.06 23.06 0 01-6.1 8A30.9 30.9 0 0124.1 43a30.9 30.9 0 01-10-5.34c-.46-.4-.84-.76-1.22-1.12L5.7 43.72A1.04 1.04 0 015 44a1.08 1.08 0 01-.7-.28 1.02 1.02 0 010-1.42l38-38a.96.96 0 011.081-.224zM38 29.28V11.74l-.2-.14-23.5 23.52c.34.34.68.66 1.08 1A29.039 29.039 0 0024 40.9a29.04 29.04 0 008.62-4.78A21.42 21.42 0 0038 29.28zm-28-.02A20.59 20.59 0 0011.66 32l-1.44 1.48A19.597 19.597 0 018 29.7v-19A25.12 25.12 0 0115.5 7 44.36 44.36 0 0124 5a44.362 44.362 0 018.5 1.96c1.04.337 2.062.731 3.06 1.18l-1.52 1.52c-.66-.28-1.38-.54-2.16-.8A44.32 44.32 0 0024 7.02a44.318 44.318 0 00-7.88 1.84A26 26 0 0010 11.74v17.52z",
    fill: "#1998D5"
  })));
}
export default SvgNotMonitorable;